/* src/app/components/print-product-modal/file-details/file-details.component.scss */
.ring-img {
  width: 20px;
  height: 20px;
}
.cover-img {
  width: 20px;
  height: 24px;
}
.details-container {
  border-radius: 10px;
  border: 1px solid #cbcbcb;
  background-color: white;
  padding: 10px;
}
.binding-settings {
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  color: black;
  font-family: "Barlow Semi Condensed";
}
.files-container {
  border-radius: 15px;
  border: 1px solid #949494;
  background-color: white;
}
.warning-icon {
  cursor: pointer;
  border-radius: 15px;
  border: 2px solid #f5b200;
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.1) 0%,
      rgba(245, 178, 0, 0.1) 100%),
    #fff;
  padding: 8px 10px;
  width: 24px;
  height: 24px;
  color: #d59b00;
}
ion-popover.warning-popover {
  --width: auto;
  --max-width: 340px;
}
ion-popover.warning-popover::part(content) {
  border-radius: 20px;
  padding: 20px;
}
ion-popover.warning-popover .warning-title {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
ion-popover.warning-popover .warning-message {
  border-radius: 15px;
  border: 2px solid #f5b200;
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.1) 0%,
      rgba(245, 178, 0, 0.1) 100%),
    #fff;
  padding: 12px 15px;
  align-items: center;
  width: fit-content;
  position: sticky;
  top: 0;
  z-index: 9;
  color: #d59b00;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  white-space: pre-wrap;
  text-align: start;
}
ion-popover.warning-popover .warning-message ion-icon {
  width: 30px;
  height: 30px;
}
.file-info-wrapper {
  border-radius: 15px;
  background-color: #f6f6f6;
  padding: 10px;
}
.file-info-container {
  border-radius: 10px;
  border: 1px solid #949494;
  background-color: white;
  padding: 10px;
}
.file-info-container .blank-sheets-text {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.file-info-container .blank-sheets-text span {
  font-weight: 600;
}
.file-info-container .blank-sheets-number {
  color: #259dff;
  text-align: right;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.file-img {
  max-height: 65px;
  aspect-ratio: 46/65;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
}
.file-name {
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.file-color {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
.file-pages {
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #949494;
}
.coverTypeIcon {
  width: 20px;
  height: 20px;
}
.annotations-row > span {
  border-radius: 20px;
  padding: 3px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
}
.annotations-row > span.blue {
  background-color: #d4ecff;
  color: #259dff;
}
.annotations-row > span.pink {
  color: #c80064;
  background-color: #ffd5eb;
}
.annotations-row > span.yellow {
  color: #d59b00;
  background-color: #fff0c6;
}
.view-details-button {
  --color: #259dff;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  min-height: 0;
  --border-radius: 0px;
}
.view-details-button ion-icon {
  width: 13px !important;
  height: 15px !important;
  margin-left: 5px;
}
.view-details-button::part(native) {
  padding: 0;
}
.coverTypeIcon {
  width: 20px;
  height: 20px;
}
.annotations-row > span {
  border-radius: 20px;
  padding: 4px 8px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  line-height: normal;
  font-weight: 500;
}
.annotations-row > span.blue {
  background-color: #d4ecff;
  color: #259dff;
}
.annotations-row > span.pink {
  color: #c80064;
  background-color: #ffd5eb;
}
.annotations-row > span.yellow {
  color: #d59b00;
  background-color: #fff0c6;
}
.cover-text {
  color: #000;
  font-family: "Barlow Semi Condensed";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.blank-sheets-text {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.blank-sheets-text span {
  font-weight: 600;
}
.blank-sheets-number {
  color: #259dff;
  text-align: right;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
/*# sourceMappingURL=file-details.component-GCKLMEZ5.css.map */
